<div class="notifications">
  <h2>Notifications</h2>
  <div class="buttons">
    <button
      matButton="filled"
      [class.active]="currentList === 'all'"
      (click)="switchDisplayedNotifications('all')"
    >
      All
    </button>
    <button
      matButton="filled"
      [class.active]="currentList === 'unread'"
      (click)="switchDisplayedNotifications('unread')"
    >
      Unread
    </button>
    <button matButton>Mark all as read</button>
  </div>
  <div class="cards">
    @for (notification of displayedNotifications(); track notification._id) {
      <div class="card">
        <fa-icon
          class="icon"
          [icon]="['fas', iconsMap[notification.level].name]"
          size="lg"
          [style.color]="iconsMap[notification.level].color"
        ></fa-icon>
        <div class="texts">
          <h3>{{ notification.title }}</h3>
          <p>{{ notification.body }}</p>
          <span>{{ notification.date | date: 'dd.MM.yyyy, HH:mm:ss' }}</span>
        </div>
      </div>
    }
  </div>
</div>
